var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_vm._t("default",function(){return [_c('span',{staticClass:"tooltip-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.link)?_c('a',{attrs:{"href":_vm.link,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c91897","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/tooltips/Tooltip.vue
// module id = null
// module chunks = 